import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {ARTIFACT_VERSION_PATH} from '../artifacts/artifactPaths';
import {type RouteData} from '../types';
import {REGISTRY_PATHS} from './registryPaths';

export const REGISTRY_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      skipTracking: true, // HomepageSidebarRegistriesRouter handles tracking for the nested routes
    },
    exact: true,
    isPrivateRoute: true,
    path: REGISTRY_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/HomePage/HomePageWithData')
    ).Component,
  },
  {
    path: `${ARTIFACT_VERSION_PATH}/graph`,
    redirect: `${ARTIFACT_VERSION_PATH}/lineage`,
  },
  {
    path: '/models',
    redirect: '/registry/model',
  },
];
